export enum SurveyStatusEnum {
  NO_SURVEY = 'NO_SURVEY',
  LOCKED = 'LOCKED',
  ALLOWED = 'ALLOWED',
  COMPLETED = 'COMPLETED',
}
